import { Card, Select, Input } from '../design-system/components';

const STAT_TILES = [
  { key: 'requested', label: 'Requested', accent: 'var(--accent)' },
  { key: 'processing', label: 'Processing', accent: 'var(--secondary)' },
  { key: 'scheduled', label: 'Scheduled', accent: 'var(--success)' },
  { key: 'availableSlots', label: 'Available Slots', accent: 'var(--info)' },
];

/**
 * Request filters component
 * Provides filtering controls for status, date, venue, and search
 */
export const RequestFilters = ({
  statusFilter,
  setStatusFilter,
  dateFilter,
  setDateFilter,
  venueFilter,
  setVenueFilter,
  searchTerm,
  setSearchTerm,
  uniqueDates,
  uniqueVenues,
  requestStats
}) => {
  return (
    <div className="space-y-4">
      {/* Stats */}
      {requestStats && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {STAT_TILES.map((tile) => (
            <Card key={tile.key} accent={tile.accent} padding="var(--space-4)">
              <div style={{ fontFamily: 'var(--font-sans)', fontWeight: 'var(--fw-bold)', fontSize: 'var(--text-xs)', letterSpacing: 'var(--ls-caps)', textTransform: 'uppercase', color: 'var(--text-muted)' }}>
                {tile.label}
              </div>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-2xl)', fontWeight: 'var(--fw-bold)', color: 'var(--text-strong)' }}>
                {requestStats[tile.key]}
              </div>
            </Card>
          ))}
        </div>
      )}

      {/* Filter Controls */}
      <Card>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <Select
            label="Request Status"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">All Requests</option>
            <option value="Requested">Requested</option>
            <option value="Processing">Processing</option>
            <option value="Scheduled">Scheduled</option>
            <option value="Denied">Denied</option>
            <option value="Cancelled">Cancelled</option>
            <option value="Stale">Stale (5+ days in Processing)</option>
          </Select>

          <Select
            label="Date"
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
          >
            <option value="">All Dates</option>
            {uniqueDates.map((date) => (
              <option key={date} value={date}>
                {date}
              </option>
            ))}
          </Select>

          <Select
            label="Venue"
            value={venueFilter}
            onChange={(e) => setVenueFilter(e.target.value)}
          >
            <option value="all">All Venues</option>
            {uniqueVenues.map((venue) => (
              <option key={venue} value={venue}>
                {venue}
              </option>
            ))}
          </Select>

          <Input
            label="Search Requests"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Team, contact..."
            icon="search"
          />
        </div>
      </Card>
    </div>
  );
};
